<template>
    <v-container :style="cssProps" v-if="loading === false">
        <h1 class="titulo mb-5">INICIAR VENDA</h1>

        <v-stepper class="card" v-model="current_page">
            <v-row justify="center"
                   class="header-steps">
                <v-col class="d-flex steps-container">
                    <template v-for="(step, i) in Steps">
                        <v-stepper-step :key="i" class="flex justify-center" :class="{'step-hoverable' : isStepPrevious(i)}" :complete="current_page > i+1" :step="i+1">
                            <template v-if="isStepPrevious(i)">
                                <v-tooltip top
                                           max-width="250px"
                                           color="warning"
                                           nudge-right="160"
                                >
                                    <template #activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs" style="display: flex; align-items: center;" @click="abrirModalConfirmacao(i)">
                                            <p class="step-label titulo">
                                                <v-icon>{{ step.icon }}</v-icon>
                                                {{ step.text }}
                                            </p>
                                        </div>
                                    </template>
                                    <div class="d-flex align-center">
                                        <v-icon color="black" class="font-weight-bold mr-2">mdi-information</v-icon>
                                        <span style="color: black" class="font-weight-bold text-center">Clique aqui para voltar até essa etapa!</span>
                                    </div>
                                </v-tooltip>
                            </template>
                            <template v-else>
                                <div style="display: flex; align-items: center;">
                                    <p class="step-label titulo">
                                        <v-icon>{{ step.icon }}</v-icon>
                                        {{ step.text }}
                                    </p>
                                </div>
                            </template>
                        </v-stepper-step>
                    </template>
                </v-col>
                <DialogVoltarEtapas
                        v-model="showModal"
                        @confirm="voltarEtapa()"
                />
            </v-row>

            <v-stepper-items>
                <v-col v-if="(pedido && pedido.id_reserva && !(pedido.carrinho && pedido.carrinho.id_carrinho))" class="text-end">Cod. Reserva: {{ pedido.id_reserva }}</v-col>
                <v-col v-if="(pedido && pedido.id_reserva && (pedido.carrinho && pedido.carrinho.id_carrinho))" class="d-flex justify-end mt-1 mr-1">
                    <ToolTip
                            label-text="Múltiplas Cotas*"
                            bottom
                            color="white"
                            :content="`${pedido.carrinho.qt_cotas} cotas selecionadas.`"
                            text-color="dark--text"
                            :icon-attrs="{ color: 'dark' }"
                            icon="info"
                            :content-style="{color: 'var(--primary)' }"
                    ></ToolTip>
                </v-col>
                <v-stepper-content class="step-content" :step="Pages.Cliente">
                    <Cliente v-if="current_page === Pages.Cliente" @nextPage="nextCliente" @prevPage="prevClient" :tela="tela_cliente" v-model="pedido" />
                </v-stepper-content>
                <v-stepper-content class="step-content" :step="Pages.Produto">
                    <Produto ref="produtoRef" v-if="current_page === Pages.Produto" @prevPage="prevProduto" @nextPage="current_page++" v-model="pedido" :filtro-catalogo="filtro_catalogo" :tela="tela_produto" @filtroCatalogo="aplicaFiltroCatalogo" @telaProduto="telaproduto" @showModalBroker="showModalBroker = $event" />
                </v-stepper-content>
                <v-stepper-content class="step-content" :step="Pages.Grupo">
                    <Grupo v-if="current_page === Pages.Grupo" @prevPage="prevGrupo" @nextPage="nextGrupo" @reload="initialize" :tela="tela_grupo" v-model="pedido" />
                </v-stepper-content>
                <v-stepper-content class="step-content" v-if="Pages.Cotas" :step="Pages.Cotas">
                    <Cotas v-if="current_page === Pages.Cotas" @prevPage="prevCotas" @nextPage="nextCotas" v-model="pedido" />
                </v-stepper-content>
                <v-stepper-content class="step-content" :step="Pages.Confirmacao">
                    <Confirmacao v-if="current_page === Pages.Confirmacao" @prevPage="prevResumo" @nextPage="nextContrato" @finalizado="setFinalizado" @reload="initialize" :tela="tela_confirmacao" v-model="pedido" />
                </v-stepper-content>
                <v-stepper-content class="step-content" :step="Pages.Contrato">
                    <Contrato v-if="current_page === Pages.Contrato && exibe_asssinatura_obrigatoria_tela_pagamento" @prevPage="prevContrato" @nextPage="current_page++" @finalizado="setFinalizado" @reload="initialize" :tela="tela_contrato" v-model="pedido" />
                    <ContratoAssinaturaAlocacao v-if="current_page === Pages.Contrato && !exibe_asssinatura_obrigatoria_tela_pagamento" @prevPage="prevContrato" @nextPage="current_page++" @finalizado="setFinalizado" @reload="initialize" :tela="tela_contrato" v-model="pedido" />
                </v-stepper-content>
                <v-stepper-content class="step-content" :step="Pages.Pagamento">
                    <FormaPagamento v-if="current_page === Pages.Pagamento" @prevPage="irParaDadosBancarioouContrato()" @nextPage="irParaProximaPaginaOuDetalhesMultiplos" v-model="pedido" @finalizado="setFinalizado" />
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      <PreparacaoAmbienteBroker :show="showModalBroker" :pedido="pedido" @finished="onPreparacaoFinished" @goToSales="irParaListagem"
    />
    </v-container>
</template>

<script>
  // Páginas
  import Cliente from './cliente/Cliente'
  import Produto from './produto/Produto'
  import Grupo from './grupo/Grupo'
  import Confirmacao from './confirmacao/Confirmacao'
  import Contrato from './contrato/Contrato'
  import FormaPagamento from './pagamento/FormaPagamento'
  import Cotas from './cotas/Cotas.vue'
  // Libs
  import Color from 'color'
  import { colorRes } from '@/plugins/flavors'
  import { alert, error, swap, isVendaNaoGerada } from '@/plugins/helpers'
  import { get } from 'lodash'
  import { FormasPagamento, OrigemPedido, StatusPedido, StatusContrato } from '@/plugins/constants'
  import { mapState } from 'vuex'
  import DialogVoltarEtapas from '@/components/DialogVoltarEtapas.vue'
  import ContratoAssinaturaAlocacao from '@/views/cadastro/alocacao/ContratoAssinaturaAlocacao'
  import conferirIntegridadeIniciarVenda from '../../mixins/CommercialHierarchy/conferirIntegridadeIniciarVenda'
  import preparacaoAmbienteBrokerMixin from '@/mixins/broker/preparacaoAmbienteBrokerMixin'
  import PreparacaoAmbienteBroker from '@/components/broker/PreparacaoAmbienteBroker.vue'

  export default {
    name: 'Cadastro',
    components: { ContratoAssinaturaAlocacao, Cliente, Produto, Grupo, Confirmacao, Contrato, FormaPagamento, Cotas, DialogVoltarEtapas, PreparacaoAmbienteBroker },
    mixins: [conferirIntegridadeIniciarVenda, preparacaoAmbienteBrokerMixin],
    data: () => ({
      current_page: 1,
      current_step_page: 1,
      showModal: false,
      navegacaoConfirmada: false,
      selectedStep: null,
      tela_grupo: null,
      tela_confirmacao: null,
      tela_contrato: null,
      pedido: {
        origem: OrigemPedido.web,
        backing_register: false,
        multiplicador_cota_habilitado_na_venda: false,
        tela_resumo: null
      },
      filtro_catalogo: {},
      tela_cliente: 'pessoa',
      tela_produto: 'produto',
      loading: true,
      finalizado: false,
      assinatura_obrigatoria_grupos_pontuais: false,
      assinatura_obrigatoria_grupos_convencionais: false,
      exibe_asssinatura_obrigatoria_tela_pagamento: true,
      forcarSaida: false
    }),
    computed: {
      ...mapState([
        'token',
        'permite_multiplicar_cota'
      ]),
      cssProps () {
        return {
          '--secondaryTransparent': Color(colorRes().secondary).alpha(0.15),
          '--primaryTransparent': Color(colorRes().primary).alpha(0.15)
        }
      },
      exibirAssinaturaContrato () {
        return this.assinatura_obrigatoria_grupos_pontuais || this.assinatura_obrigatoria_grupos_convencionais
      },
      exibirContratoAlocacao () {
        return !this.exibe_asssinatura_obrigatoria_tela_pagamento
      },
      fluxoProduto () {
        return this.$route.name === 'iniciar-venda'
      },
      Pages () {
        const Pages = {
          Cliente: 1,
          Produto: 2,
          Grupo: 3,
          Confirmacao: 4,
          Contrato: 5,
          Pagamento: 6
        }
        if (this.exibirAssinaturaContrato && this.exibirContratoAlocacao) {
          Pages.Pagamento = 5
          Pages.Contrato = 6
        }
        if (this.fluxoProduto) {
          Pages.Produto = 1
          Pages.Grupo = 2
          Pages.Cliente = 3
        }
        if (this.permite_multiplicar_cota) {
          Pages.Cotas = 4
          Pages.Confirmacao++
          Pages.Contrato++
          Pages.Pagamento++
        }
        return Pages
      },
      Steps () {
        let Steps = [
          { icon: 'rod-cadastro', text: 'Cadastro' },
          { icon: 'rod-produto', text: 'Produto' },
          { icon: 'rod-grupo', text: 'Grupo' },
          { icon: 'ol-book', text: 'Confirmação' },
          { icon: 'gesture', text: 'Contrato' },
          { icon: 'rod-cartao', text: 'Pagamento' }
        ]
        if (this.exibirAssinaturaContrato && this.exibirContratoAlocacao) {
          Steps = swap(Steps, 4, 5)
        }
        if (this.fluxoProduto) {
          Steps = swap(Steps, 0, 1)
          Steps = swap(Steps, 1, 2)
        }
        if (this.permite_multiplicar_cota) {
          Steps.splice(3, 0, { icon: 'mdi-cart-variant', text: 'Cotas' })
        }
        return Steps
      }
    },
    watch: {
      'pedido.current_page' () {
        this.pedido.backing_register = false
      }
    },
    created () {
      this.initialize(this.$route.params)
        .finally(() => {
          this.loading = false
        })
    },
    mounted () {
      window.addEventListener('beforeunload', this.confirmBeforeUnload)
      this.verificarSePodeProsseguirVenda()
    },
    beforeDestroy () {
      window.removeEventListener('beforeunload', this.confirmBeforeUnload)
    },
    methods: {
      telaproduto (tela) {
        this.tela_produto = tela
      },
      isStepPrevious (stepIndex) {
        const status = this.pedido.status_pedido
        const estaNoPagamento = this.current_page === this.Pages.Pagamento
        const querVoltarParaConfirmacao = (stepIndex + 1) === this.Pages.Confirmacao

        if (status === StatusPedido.AprovadoAnaliseCredito && estaNoPagamento && querVoltarParaConfirmacao) {
          return true
        }

        if (status === StatusPedido.Rascunho || status == null) {
          return (stepIndex + 1) < this.current_page
        }

        return false
      },
      abrirModalConfirmacao (step) {
        this.selectedStep = step
        this.showModal = true
      },

      voltarEtapa () {
        if (this.selectedStep !== null) {
          this.current_page = this.selectedStep + 1

          this.pedido.backing_register = true

          if (this.pedido.politica_vendas) {
            this.navegacaoConfirmada = true

            if (this.current_page === this.Pages.Produto) {
              this.$router.push({
                name: 'politica-vendas',
                params: { ...this.pedido.dados_politica_vendas }
              })
            }

            if (this.current_page === this.Pages.Grupo) {
              this.$router.push({
                name: 'selecionar-bem-politica-vendas',
                params: { ...this.pedido.dados_politica_vendas }
              })
            }
          }

          switch (this.current_page) {
            case this.Pages.Produto:
              this.tela_produto = 'prazo'
              break
            case this.Pages.Cliente:
              this.tela_cliente = 'endereco'
              break
            case this.Pages.Confirmacao:
              this.tela_confirmacao = 'selecionar_prazo_parcela'
          }
          this.selectedStep = null
          this.showModal = false
        }
      },

      prevClient () {
        if (this.pedido.politica_vendas) {
          // noinspection JSIgnoredPromiseFromCall
          this.$router.push({
            name: 'selecionar-bem-politica-vendas',
            params: { ...this.pedido.dados_politica_vendas }
          })
        } else if (this.fluxoProduto) {
          this.current_page = this.Pages.Grupo
        }
      },
      prevProduto () {
        this.tela_cliente = 'endereco'
        this.current_page--
        this.pedido.backing_register = true
      },
      prevCotas () {
        this.tela_cliente = 'endereco'
        this.current_page--
        this.pedido.backing_register = true
      },
      nextCotas () {
        this.current_page++
      },
      prevGrupo () {
        this.tela_produto = 'prazo'
        this.current_page--
      },
      prevResumo () {
        this.tela_cliente = 'endereco'
        this.tela_confirmacao = 'resumo'

        if (this.pedido.id_reserva && this.pedido.completa) {
          this.current_page = this.Pages.Cliente
        } else {
          this.current_page--
        }
        this.pedido.backing_register = true
      },
      prevContrato () {
        this.tela_confirmacao = 'selecionar_prazo_parcela'
        this.current_page--
      },
      async initialize (pedido) {
        await this.loadParams(pedido)
        this.clearCacheSession()

        if (typeof this.pedido.tela !== 'undefined' && this.pedido.tela !== '' && this.pedido.tela === 'selecionar_prazo_parcela') {
          this.irParaDadosBancarioouContrato()
        } else {
          // Checa se é uma edição ou reserva
          if (this.pedido && (this.pedido.id_pedido || this.pedido.id_reserva)) {
            this.exibe_asssinatura_obrigatoria_tela_pagamento = this.pedido.origem_assinatura === 'pagamento'
            if (this.pedido.enviado) {
              if (([ FormasPagamento.Cartao, FormasPagamento.Boleto ].includes(this.pedido.forma_pagamento) && this.pedido.enviado && !this.pedido.pagamento_enviado) ||
                ((!this.pedido.assinatura_obrigatoria || (this.pedido.assinatura_obrigatoria && (this.pedido.origem_assinatura === 'alocação cota' || this.pedido.origem_assinatura === 'pagamento') && this.pedido.status_pedido !== StatusPedido.AguardandoAssinaturaContratoAlocacao)) && !this.pedido.pagamento_enviado && this.pedido.enviado)) {
                this.current_page = this.Pages.Pagamento
              } else {
                this.irParaResumoouContrato()
              }
            } else {
              if (this.pedido.id_reserva) {
                const enderecos = get(this.pedido, 'cliente.enderecos', null)
                if (!this.pedido.enviado && (enderecos && enderecos.length >= 1) && ((this.pedido.bem || this.pedido.id_bem))) {
                  if (this.permite_multiplicar_cota) {
                    this.irParaCotas()
                    return
                  }
                }
                if ((this.pedido.bem || this.pedido.id_bem) && this.pedido.id_pedido) {
                  if (enderecos && enderecos.length >= 1) {
                    this.irParaResumoouContrato()
                  } else {
                    this.current_page = this.Pages.Cliente
                  }
                } else {
                  this.current_page = this.Pages.Produto
                }
              } else {
                const enderecos = get(this.pedido, 'cliente.enderecos', null)
                if (!this.pedido.enviado && (enderecos && enderecos.length >= 1) && ((this.pedido.bem || this.pedido.id_bem))) {
                  if (this.permite_multiplicar_cota) {
                    this.irParaCotas()
                    return
                  }
                }
                if (enderecos && enderecos.length >= 1) {
                  if (this.pedido.bem || this.pedido.id_bem) {
                    this.irParaResumoouContrato()
                  } else {
                    this.current_page = this.Pages.Produto
                  }
                } else {
                  this.current_page = this.Pages.Cliente
                  if (this.pedido.id_cliente) {
                    this.tela_cliente = 'endereco'
                  }
                }
              }
            }
          }
        }
      },
      clearCacheSession () {
        this.$session.set('index_endereco_comercial', null)
        this.$session.set('index_endereco_residencial', null)
      },
      setFinalizado () {
        this.finalizado = true
      },
      async loadParams (params) {
        if (params) {
          this.pedido = { ...this.pedido, ...params }

          if (typeof this.pedido.tela !== 'undefined' && this.pedido.tela !== '') {
            this.tela = this.pedido.tela
          }
          if (this.pedido.id_reserva) {
            await this.getReserva(this.pedido.id_reserva)
          }
          if (this.pedido.id_cliente) {
            await this.getCliente(this.pedido.id_cliente)
          }
          await this.loadConfiguracao()
        }
      },
      aplicaFiltroCatalogo (filtro) {
        this.filtro_catalogo = filtro
      },
      irParaResumoouContrato () {
        if (!isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.assinatura_obrigatoria && this.pedido.status !== StatusContrato.ContratoCancelado && this.pedido.status !== StatusContrato.ContratoRejeitado && this.pedido.status_pedido !== StatusPedido.FalhaAlocacao) {
          if (this.pedido.origem_assinatura === 'pagamento') {
            if (this.pedido.enviado) {
              this.tela_contrato = 'selecionar_assinatura'
            }
            this.exibe_asssinatura_obrigatoria_tela_pagamento = true
          } else {
            this.exibe_asssinatura_obrigatoria_tela_pagamento = false
          }
          this.current_page = this.Pages.Contrato
        } else {
          this.irParaResumo()
        }
      },
      irParaResumo () {
        this.tela_confirmacao = 'resumo'
        this.current_page = this.Pages.Confirmacao
      },
      irParaCotas () {
        this.current_page = this.Pages.Cotas
      },
      irParaDadosBancarioouContrato () {
        this.tela_confirmacao = this.pedido.tela ?? 'resumo'
        this.current_page = this.Pages.Confirmacao
      },
      nextCliente () {
        if (((this.pedido.bem && this.pedido.bem.id_bem) || this.pedido.id_bem) && (this.pedido.id_grupo || (this.pedido.grupo && this.pedido.grupo.id_grupo))) {
          if (this.permite_multiplicar_cota) {
            this.irParaCotas()
          } else {
            this.irParaResumo()
          }
        } else {
          this.current_page++
        }
      },
      nextContrato () {
        if ((this.assinatura_obrigatoria_grupos_pontuais && this.pedido.grupo_pontual) || (this.assinatura_obrigatoria_grupos_convencionais && !this.pedido.grupo_pontual)) {
          if (this.exibe_asssinatura_obrigatoria_tela_pagamento) {
            this.current_page = this.Pages.Contrato
          } else {
            this.current_page = this.Pages.Pagamento
          }
        } else {
          this.current_page = this.Pages.Pagamento
        }
      },
      nextGrupo () {
        if (this.fluxoProduto) {
          this.tela_cliente = 'pessoa'
        }
        this.current_page++
      },
      async getCliente (id_cliente) {
        try {
          const result = await this.$http.get(`/clientes/${id_cliente}`)
          this.pedido = { ...this.pedido, cliente: result.data }
        } catch (err) {
          error(err, 'Não foi possível buscar o cliente!')
        }
      },
      async getReserva (id_reserva) {
        try {
          const result = await this.$http.get(`reserva/${id_reserva}`)
          result.data.id_bem = this.pedido.id_bem && this.pedido.id_bem > 0 ? this.pedido.id_bem : result.data.id_bem
          this.pedido = { ...this.pedido, ...result.data }
        } catch (err) {
          error(err, 'Não foi possível carregar a reserva!')
        }
      },
      async loadConfiguracao () {
        await this.$http.get('/configuracao/get')
          .then(result => {
            if (result.data) {
              this.assinatura_obrigatoria_grupos_pontuais = result.data.assinatura_obrigatoria_grupos_pontuais
              this.assinatura_obrigatoria_grupos_convencionais = result.data.assinatura_obrigatoria_grupos_convencionais
              this.exibe_asssinatura_obrigatoria_tela_pagamento = result.data.exibe_asssinatura_obrigatoria_tela_pagamento
              this.$store.state.permite_multiplicar_cota = result.data.permite_multiplicar_cota
            }
          })
          .catch(err => error(err, 'Não foi possível buscar a configuração!'))
      },
      confirmReload (next) {
        alert({
          text: 'Tem certeza que deseja sair? Você perderá mudanças não salvas!',
          buttons: {
            'Cancelar': () => next(false),
            'Confirmar': () => {
              this.$session.set('nm_tabela_venda', null)
              next()
            }
          }
        })
      },
      confirmBeforeUnload (event) {
        event.preventDefault()
        event.returnValue = '' // Esta linha é necessária para exibir o diálogo de confirmação padrão
        return 'Tem certeza que deseja sair?'
      },
      irParaProximaPaginaOuDetalhesMultiplos () {
        if (this.pedido.carrinho && this.pedido.carrinho.qt_cotas > 1) {
          return this.$router.replace({ name: 'detalhes-carrinho', params: { id_pedido: this.pedido.id_pedido } })
        }
        this.current_page++
      },
      onPreparacaoFinished () {
        this.showModalBroker = false
        // Chama o método do Produto, que chama do SelecionarBem
        if (this.$refs.produtoRef && this.$refs.produtoRef.onPreparacaoFinished) {
          this.$refs.produtoRef.onPreparacaoFinished()
        }
      },
      irParaListagem () {
        this.forcarSaida = true
        this.showModalBroker = false
        this.$session.set('nm_tabela_venda', null)
        this.$router.push({ name: 'minhas-vendas' })
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.forcarSaida) {
        this.forcarSaida = false
        return next()
      }
      if (this.navegacaoConfirmada) {
        this.navegacaoConfirmada = false
        next()
      } else if (!from.name) {
        this.confirmReload(next)
      } else if (to.name === 'logout' || !this.token || this.finalizado || (this.is_usuario_logado_hierarquia && to.query.redirecionamentoPainelLateral)) {
        next()
      } else {
        this.confirmReload(next)
      }
    }
  }
</script>

<style lang="scss" scoped>
   .header-steps {
        border-bottom: 1px solid var(--lightgray)
    }

    .step-hoverable {
        position: relative;
        overflow: hidden;
        z-index: 0;
        transition: color 0.2s;
    }

    .step-hoverable::before {
        content: "";
        position: absolute;
        top: 0; left: 0; bottom: 0;
        width: 0;
        background: var(--secondaryTransparent);
        z-index: -1;
        transition: width 0.3s;
    }

    .step-hoverable:hover::before {
        width: 100%;
    }

    .step-hoverable .step-label {
        cursor: pointer;
    }

    .step-hoverable:hover .step-label,
    .step-hoverable:hover .v-icon {
        color: var(--secondary) !important;
    }

    .header-steps {
        border-bottom: 1px solid var(--lightgray)
    }

    .steps-container {
        max-width: 1200px;
        border-bottom: 1px solid var(--lightgray);
        white-space: nowrap;
    }

    .steps-container .v-icon {
        vertical-align: middle;
        font-size: 18px;
        margin-right: 5px;
        margin-top: -2px;
    }

    .steps-container .step-label {
        display: block !important;
        text-transform: uppercase;
        font-size: 14px;
        margin-bottom: 0;
    }

    .steps-container .step-label, .steps-container .v-icon {
        color: var(--gray);
    }

    .steps-container .v-stepper__step--active {
        background: var(--secondaryTransparent);
    }

    .steps-container .v-stepper__step--active .step-label,
    .steps-container .v-stepper__step--active .v-icon {
        color: var(--secondary);
    }

    .steps-container .v-stepper__step--complete .step-label,
    .steps-container .v-stepper__step--complete .v-icon {
        color: var(--primary);
    }

    .step-content {
        padding: 15px;
    }
</style>

<!--suppress CssUnusedSymbol -->
<style>
    .v-stepper__step__step {
        display: none !important;
    }

    .v-stepper__label {
        display: block !important;
    }
</style>
